namespace SorAraBul.Administration {
    export namespace UserCreditLogService {
        export const baseUrl = 'Administration/UserCreditLog';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UserCreditLogRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Administration/UserCreditLog/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>UserCreditLogService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
